export default __webpack_public_path__ + "static/media/saveFile.9d22ef5f.svg";